import { ListItem } from '@mui/material';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import SearchPost from './SearchPost';
import Arrow from "../../assets/SettingsPage/SVG/Arrow 1.svg";

import { useNavigate } from 'react-router-dom';
import { followerDel, followingDel } from '../../Api/firestoreApis';

function Following() {

    const followingData = useSelector((state) => state.Event).followingData;
    
    const navigate = useNavigate()
  const navigatorfun = () => {
    navigate("/profile-page");
  }
    return (
        <>
    
        <div
          className="m-[20px] cursor-pointer"
          onClick={() => {
            navigatorfun()
          }}
        >
          <img src={Arrow} />
        </div>
            <>
                {followingData.map((hit, index) => {
                    
                    return (
                        <ListItem key={hit.obj["uid"]}>
                            <Followingdd hit={hit.obj} index={index}/>
                        </ListItem>
                    )
                })}
            </>

        </>
    );
}

export default Following


export function Followingdd(props) {
   const [followingt,setfollowingt]=useState(true)
   const followingData = useSelector((state) => state.Event).followingData;
   const dispatch = useDispatch();

   const UnFollow = async (uid) => {
    setfollowingt(false)
    const result = followingData.filter(checkAdult);
        function checkAdult(followingData) {
            return followingData["obj"]["uid"] != uid;
        }

        dispatch({
            type: "FOLLOWING_DATA",
            followingData: result,
          });
          setfollowingt(false)
        
        let followingId = uid
        let userid = localStorage.getItem('uid');
        await followingDel(followingId, userid)
        await followerDel(followingId, userid)
   }


    return (
        <div className='row post-container' style={{ color: 'white' }}>
            <div className='img-container-post'>

                <img className='profile__pic--medium' src={!props.hit["profilePic"] ? process.env.PUBLIC_URL + '/icon.jpg' : props.hit["profilePic"].url} />
                <div className='col center' style={{ textAlign: 'left', maxWidth: 100 }}>

                    <p className='notification__body--text' style={{ color: 'white', fontSize: 14, fontWeight: 500, paddingBottom: 0, lineHeight: '18px', }}>{props.hit["name"]}</p>
                    <p className='notification__body--text' style={{ color: 'white', fontSize: 14, fontWeight: 500, paddingBottom: 0, lineHeight: '18px', }}>{props.hit["username"]}</p>
                </div>
            </div>
            <div className='col center' style={{
                textAlign: 'left'
            }}>
                <button onClick={() => { followingt ? UnFollow(props.hit["uid"]) : UnFollow() }} className='btn'>{followingt ? "UnFollow" : "Follow"}</button>
            </div>
        </div>
    )
}